import Vue from "vue";
import Router from "vue-router";
import {getUser, getUserToken} from "../utils/helper";
import store from "../store";
// import { UserService } from '../common/api.service';
import {CHECK_AUTH} from "../store/actions.type";
import traineeFacilities from "../components/Lookups/trainee-facility/traineeFacility.vue";

Vue.use(Router);

// const ifNotAuthenticated = async (to, from, next) => {
//   if (!getUserToken()) {
//     next();
//     return;
//   }
//   next("/");
// };

const ifAuthenticated = async (to, from, next) => {
    if (getUserToken()) {
        next();
        return;
    }
    next("/login");
};

const isAuthorized = async (to, from, next) => {
    if (to.type != "public") {
        if (
            !getUser().permissions.some(
                (permission) => permission.menuItem.menuItemName === to.name
            )
        ) {
            next("/unauthorized");
        } else {
            if (
                getUser().permissions.some(
                    (permission) =>
                        permission.menuItem.menuItemName === to.name &&
                        permission.canRead == false
                )
            ) {
                next("/unauthorized");
            }
            next();
        }
    } else {
        next();
    }
};

export const router = new Router({
    mode: "history",
    meta: {title: "Home"},
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "app",
            type: "public",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Index"),
            children: [
                {
                    name: "Default",
                    path: "/hrd",
                    type: "public",

                    component: () => import("@/components/Dashboard/Dashboard"),
                },
                {
                    name: "Dashboard",
                    path: "/dashboard",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Dashboard/Dashboard"),
                },
                {
                    name: "Pre-Service",
                    path: "/preservice",
                    type: "private",
                    // beforeEnter: isAuthorized,
                    component: () => import("@/components/PreService/PreService"),
                },
                {
                    name: "Map",
                    path: "/map",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Map/Map"),
                },
                {
                    name: "Online Status",
                    path: "/onlineStatus",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/OnlineStatus/onlineStatus.vue"),
                },
                {
                    name: "Course",
                    path: "/course",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Courses/Course"),
                },
                {
                    name: "CPD Activity",
                    path: "/cpdActivity",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Programs/Program"),
                },
                {
                    name: "CPD Provider",
                    path: "/cpdProvider",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/TrainingCenter/TrainingCenter"),
                },
                {
                    name: "Trainer",
                    path: "/trainer",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Trainers/Trainer"),
                },
                {
                    name: "Monitoring",
                    path: "/graduateTracking",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/GraduateTracks/GraduateTracking"),
                },
                {
                    name: "Trainee",
                    path: "/traineeRegistration",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Trainees/Trainee"),
                },
                {
                    name: "Pre-service",
                    path: "/pre-service",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Graduates/Graduates"),
                },
                {
                    name: "Program Event",
                    path: "/programEvent",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/ProgramEvents/ProgramEvent"),
                },
                {
                    name: "Users",
                    path: "/user",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Settings/User/User"),
                },
                {
                    name: "User Groups",
                    path: "/userGroup",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Settings/UserGroup/Usergroup"),
                },
                {
                    name: "Roles",
                    path: "/role",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Settings/Role/Role"),
                },
                {
                    name: "Menu Items",
                    path: "/menuItem",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Settings/MenuItem/MenuItem"),
                },
                {
                    name: "Permissions",
                    path: "/permission",
                    type: "private",
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Settings/Permission/Permission"),
                },
                {
                    name: "Register Trainee",
                    path: "/registerTrainee",
                    type: "public",
                    props: true,
                    // beforeEnter:isAuthorized,
                    component: () =>
                        import("@/components/Trainees/new-trainee/hrd-register-trainee"),
                },
                {
                    name: "Training Event Report",
                    path: "/trainingEventReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Reports/registration-report/registration-report"
                            ),
                },
                {
                    name: "CPD Provider Report",
                    path: "/cpdReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Reports/cpd-provider-report/cpd-provider-report"
                            ),
                },
                {
                    name: "CPD Accreditor",
                    path: "/Accreditor",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Accreditors/hrd-accreditors"),
                },
                {
                    name: "CPD Accreditor Report",
                    path: "/accreditorReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Reports/accreditor-report/accreditor-report"),
                },
                {
                    name: "Accredited Course Report",
                    path: "/accreditedCourseReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Reports/accredited-course-report/accredited-course-report"
                            ),
                },
                {
                    name: "Accreditation Summary Report",
                    path: "/accreditationSummaryReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Reports/accreditation-summary-report/accreditation-summary-report"
                            ),
                },
                {
                    name: "Accredited CPD Provider Report",
                    path: "/accreditedCpdProviderReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Reports/accredited-cpd-provider-report/accredited-cpd-provider-report"
                            ),
                },
                {
                    name: "Training Detail Report",
                    path: "/trainingDetailReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Reports/training-summary-report/training-summary-report"
                            ),
                },
                {
                    name: "Preservice Report",
                    path: "/preserviceReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Reports/preservice-report/pre-service-report"),
                },
                {
                    name: "Renewal Status Report",
                    path: "/renewalStatusReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Reports/renewal-status-report/renewal-status-report"),
                },
                {
                    name: "Trainee Report",
                    path: "/traineeReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Reports/trainee-report/trainee-report"),
                },
                {
                    name: "Trainer Report",
                    path: "/trainerReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Reports/trainer-report/trainer-report.vue"),
                },
                {
                    name: "Course Report",
                    path: "/courseReport",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Reports/course-report/course-report.vue"),
                },
                {
                    name: "Health Professions",
                    path: "/healthProfessions",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Lookups/health-professions/HealthProfessions"),
                },
                {
                    name: "Mfr",
                    path: "/mfr",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () => import("@/components/Lookups/mfr/mfr"),
                },
                {
                    name: "Universities",
                    path: "/universities",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Lookups/universities/universities"),
                },
                {
                    name: "Certificate Reasons",
                    path: "/certificateReasons",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Lookups/certificate-reasons/certificateReasons"
                            ),
                },
                {
                    name: "Educational Programs",
                    path: "/educationalPrograms",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import(
                            "@/components/Lookups/educational-program/educationalProgram"
                            ),
                },
                {
                    name: "Disciplines",
                    path: "/disciplines",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Lookups/disciplines/disciplines"),
                },
                {
                    name: "Level of Studies",
                    path: "/levelOfStudies",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Lookups/level-of-studies/levelOfStudies"),
                },
                {
                    name: "Facilities",
                    path: "/Facilities",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () =>
                        import("@/components/Lookups/user-facility/userFacility"),
                },
                {
                    name: "Trainee Facilities",
                    path: "/traineeFacilities",
                    type: "private",
                    props: true,
                    beforeEnter: isAuthorized,
                    component: traineeFacilities,
                },
                {
                    name: 'Trainer Selection Criteria',
                    path: '/trainerSelectionCriteria',
                    type: 'private',
                    props: true,
                    beforeEnter: isAuthorized,
                    component: () => import('@/components/Lookups/trainer-selection-criteria/trainerCriteria')
                },
            ],
        },
        {
            name: "Login",
            path: "/login",
            // beforeEnter: ifNotAuthenticated,
            type: "public",
            component: () => import("@/components/Login/Login"),
        },
        {
            name: "Reset Password",
            path: "/resetPassword/:token",
            type: "private",
            component: () => import("@/components/Login/ResetPassword"),
        },
        {
            name: "Unauthorized",
            path: "/unauthorized",
            type: "private",
            component: () => import("@/views/components/Unauthorized"),
        },
        {
            name: "Trainer Information",
            path: "/trainerInformation/:id/:category/:courseId",
            type: "private",
            // beforeEnter:isAuthorized,
            component: () => import("@/components/Trainers/trainer-public-detail"),
        },
        {
            name: "Trainee Information",
            path: "/traineeInformation/:id",
            type: "private",
            // beforeEnter:isAuthorized,
            component: () => import("@/components/Trainees/trainee-public-detail"),
        },
        {
            name: "New Trainee Information",
            path: "/newTraineeInformation/:id",
            type: "private",
            // beforeEnter:isAuthorized,
            component: () => import("@/components/Trainees/new-trainee-public-info"),
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    if (!store.getters.currentUser.token) {
        await Promise.all([store.dispatch(CHECK_AUTH)]);
    }
    next();
});

export default router;
